import { Switch, Route } from "react-router-dom";
import getPublicRoutes from "../navigation/PublicRoutes";
import MobileHome from "../pages/mobile/MobileHome";
import MobileCalendarUser from "../pages/mobile/MobileCalendarUser";
import MobileCalendarFull from "../pages/mobile/MobileCalendarFull";
import MobileMyHouseholds from "../pages/mobile/MobileMyHouseholds";
import MobilePickupHouseholds from "../pages/mobile/MobilePickupHouseholds";
import MobileHouseholdDetail from "../pages/mobile/MobileHouseholdDetail";
import NoteDetail from "../components/adresses/notes/NoteDetail";
import MobileUnsupportedPage from "../pages/mobile/MobileUnsupportedPage";
import { client } from "../hooks/Client";
import MobileLayout from "./MobileLayout";

const MobileNavigation = () => (
  <Switch>
    {/* Insert public routes, React Router v5 does not support nested routing components */}
    {getPublicRoutes()}

    <Route exact path={`/:orgId/`}>
      <MobileLayout>
        <MobileHome />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/dashboard`}>
      <MobileLayout>
        <MobileHome />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/mycalendar`}>
      <MobileLayout>
        <MobileCalendarUser />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/fullcalendar`}>
      <MobileLayout>
        <MobileCalendarFull />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/myhouseholds`}>
      <MobileLayout>
        <MobileMyHouseholds />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/pickuphouseholds`}>
      <MobileLayout>
        <MobilePickupHouseholds />
      </MobileLayout>
    </Route>
    {/* Path shape matters: the reused address tabs read the id from Location()[3]. */}
    <Route exact path={`/:orgId/myhousehold/:id`}>
      <MobileLayout>
        <MobileHouseholdDetail />
      </MobileLayout>
    </Route>
    <Route exact path={`/:orgId/adressnotedetail/:adressId/:noteId`}>
      <MobileLayout>
        <NoteDetail />
      </MobileLayout>
    </Route>
    {/* Opvangroute — MOET als laatste staan: `/:orgId` matcht zonder `exact`
        elk dieper pad. Zonder deze route rendert de <Switch> niets voor een
        pagina die alleen op desktop bestaat (bijv. de knop in de updatemail,
        `/<org>/updates?m=1`), en ziet de gebruiker een wit scherm. */}
    <Route path={`/:orgId`}>
      <MobileLayout>
        <MobileUnsupportedPage />
      </MobileLayout>
    </Route>
  </Switch>
);

export default MobileNavigation;